<div class="row ng-scope">
  <div class="col-12">
    <div class="row form-group">
      <label class="control-label col-3">{{'Mã' | translate}}</label>
      <div class="col-9">
        <input type="text" #mafocus [autofocus] tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ma">

      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Tên' | translate}}</label>
      <div class="col-9">
        <input type="text" (keydown)="keyTenPress($event)" tabIndex="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ten">
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Ghi chú' | translate}}</label>
      <div class="col-9">
        <textarea name="description" tabIndex="4" [(ngModel)]="doituongSelect.TenTiengNuocNgoai" placeholder="" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" rows="3"> </textarea>
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Thứ tự' | translate}}</label>
      <div class="col-9">
        <input class="form-control"
               maxlength="20"
               currencyMask
               [(ngModel)]="doituongSelect.SapXep"
               name="value"
               [placeholder]="'Số thứ tự'"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
    </div>

  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div class="checkbox c-checkbox">
    <!--<label>
            <input tabIndex="5" type="checkbox" [(ngModel)]="doituongSelect.Trang_Thai" />
        <span class="fa fa-check"></span>{{hoatdong}}</label>-->
  </div>
  <div class="">
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    <button style="float:left !important" *ngIf="!(quyen_sua==false && doituongSelect.Id!=null && doituongSelect.Id!='0')" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
  </div>

</div>


